const addSuccessTooltip = (parentElement, message) => {
    const tooltip = document.createElement('div');
    tooltip.classList.add('success-tooltip');
    tooltip.textContent = message;
    parentElement.appendChild(tooltip);
    tooltip.style.opacity = '0';
    tooltip.style.transition = 'opacity 1s ease-in-out';
    setTimeout(() => (tooltip.style.opacity = '1'), 100);
    setTimeout(() => {
        tooltip.style.opacity = '0';
        setTimeout(() => parentElement.removeChild(tooltip), 1000);
    }, 2000);
};
const initReferralButtons = () => {
    const referralForm = document.querySelector('.customer-referral-form');
    if (!referralForm) {
        return;
    }
    const copyButton = referralForm.querySelector('.copy-button');
    const sendEmailButton = referralForm.querySelector('.email-button');
    const copyTooltipElement = referralForm.querySelector('.copy-tooltip');
    const copyTooltip = copyTooltipElement
        ? copyTooltipElement.innerText
        : '✓ Der Link wurde in die Zwischenablage kopiert';
    const emailSubjectElement = referralForm.querySelector('.email-subject');
    const emailSubject = emailSubjectElement
        ? emailSubjectElement.innerText
        : 'Ich empfehle dir ebuero - für meine Freunde gibt es 200 Euro Guthaben';
    const emailTextElement = referralForm.querySelector('.email-text');
    const emailText = emailTextElement
        ? emailTextElement.innerText
        : `Hallo,\n\n ich nutze das ebuero Telefonsekretariat und glaube, das wäre auch für dich ein cooler Service! Melde dich einfach unter {{referralUrl}} an und probiere den Service mit 200 Euro Guthaben aus.\n\n Liebe Grüße!`;
    if (copyButton) {
        copyButton.addEventListener('click', () => {
            const range = document.createRange();
            const referralUrl = document.querySelector('.customer-referral-form .referral-code-url');
            if (referralUrl) {
                range.selectNode(referralUrl);
                window.getSelection()?.removeAllRanges();
                window.getSelection()?.addRange(range);
                document.execCommand('copy');
                window.getSelection()?.removeAllRanges();
                addSuccessTooltip(copyButton.parentElement, copyTooltip);
            }
        });
    }
    if (sendEmailButton) {
        sendEmailButton.addEventListener('click', () => {
            const referralUrlElement = document.querySelector('.customer-referral-form .referral-code-url');
            const referralUrl = referralUrlElement?.textContent;
            if (!referralUrl) {
                return;
            }
            const emailBody = emailText.replace('{{referralUrl}}', referralUrl);
            sendEmailButton.setAttribute('href', `mailto:?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`);
        });
    }
    const shareViaWhatsApp = () => {
        const referralUrlElement = document.querySelector('.customer-referral-form .referral-code-url');
        const referralUrl = referralUrlElement?.textContent;
        const whatsappMessage = encodeURIComponent(`${emailSubject}:\n${referralUrl}`);
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (!referralUrl) {
            return;
        }
        const whatsappLink = isMobile
            ? `whatsapp://send?text=${whatsappMessage}`
            : `https://web.whatsapp.com/send?text=${whatsappMessage}`;
        openLink(whatsappLink);
    };
    const shareViaMessenger = () => {
        const referralUrlElement = document.querySelector('.customer-referral-form .referral-code-url');
        const referralUrl = referralUrlElement?.textContent;
        const fbAppId = window.facebookAccount.appId;
        const messengerMessage = `${emailSubject}\n${referralUrl}`;
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (!referralUrl) {
            return;
        }
        if (isMobile) {
            const messengerLink = `fb-messenger://share/?link=${encodeURIComponent(referralUrl)}`;
            openLink(messengerLink);
        }
        else {
            const messengerLink = `https://www.facebook.com/dialog/send?app_id=${encodeURIComponent(fbAppId || '')}&link=${encodeURIComponent(referralUrl)}&redirect_uri=${encodeURIComponent(referralUrl || '')}&quote=${encodeURIComponent(messengerMessage)}`;
            openLink(messengerLink);
        }
    };
    const openLink = (link) => {
        if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
            window.location.href = link;
        }
        else {
            const newTab = window.open('', '_blank');
            if (newTab) {
                newTab.location.href = link;
            }
        }
    };
    const whatsappButton = document.querySelector('.whatsapp-button');
    const messengerButton = document.querySelector('.messenger-button');
    if (whatsappButton) {
        whatsappButton.addEventListener('click', shareViaWhatsApp);
    }
    if (messengerButton) {
        messengerButton.addEventListener('click', shareViaMessenger);
    }
};
export const initCustomerReferral = () => {
    const init = () => {
        initReferralButtons();
    };
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
};
